import {ValueObject} from '@s-ui/domain'

export class GetMessagingAdsListUserValueObject extends ValueObject {
  #adsList

  /**
   * @param {Array} ads
   * */
  static create({ads}) {
    return new GetMessagingAdsListUserValueObject({ads})
  }

  constructor({ads}) {
    super()
    this.#adsList = ads
  }

  toJSON() {
    return {
      ads: this.#adsList
    }
  }
}
